import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF],
  strings: ['DV_WEB_LIVE_NOT_SUPPORTED_BODY'] as const,
}
